"use strict";

var cov_1ydkxurojd = function () {
  var path = "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\verse-objects\\VerseObject.js";
  var hash = "b3ba7f1400cd4e75e3b09e71e95e24c5ab7b1db3";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\verse-objects\\VerseObject.js",
    statementMap: {
      "0": {
        start: {
          line: 21,
          column: 17
        },
        end: {
          line: 21,
          column: 28
        }
      },
      "1": {
        start: {
          line: 24,
          column: 2
        },
        end: {
          line: 65,
          column: 3
        }
      },
      "2": {
        start: {
          line: 26,
          column: 6
        },
        end: {
          line: 26,
          column: 83
        }
      },
      "3": {
        start: {
          line: 27,
          column: 6
        },
        end: {
          line: 27,
          column: 12
        }
      },
      "4": {
        start: {
          line: 29,
          column: 6
        },
        end: {
          line: 29,
          column: 59
        }
      },
      "5": {
        start: {
          line: 30,
          column: 6
        },
        end: {
          line: 30,
          column: 12
        }
      },
      "6": {
        start: {
          line: 32,
          column: 6
        },
        end: {
          line: 38,
          column: 8
        }
      },
      "7": {
        start: {
          line: 39,
          column: 6
        },
        end: {
          line: 39,
          column: 12
        }
      },
      "8": {
        start: {
          line: 41,
          column: 6
        },
        end: {
          line: 51,
          column: 7
        }
      },
      "9": {
        start: {
          line: 42,
          column: 8
        },
        end: {
          line: 48,
          column: 10
        }
      },
      "10": {
        start: {
          line: 50,
          column: 8
        },
        end: {
          line: 50,
          column: 101
        }
      },
      "11": {
        start: {
          line: 52,
          column: 6
        },
        end: {
          line: 52,
          column: 12
        }
      },
      "12": {
        start: {
          line: 54,
          column: 6
        },
        end: {
          line: 54,
          column: 62
        }
      },
      "13": {
        start: {
          line: 55,
          column: 6
        },
        end: {
          line: 55,
          column: 12
        }
      },
      "14": {
        start: {
          line: 57,
          column: 6
        },
        end: {
          line: 57,
          column: 25
        }
      },
      "15": {
        start: {
          line: 58,
          column: 6
        },
        end: {
          line: 58,
          column: 12
        }
      },
      "16": {
        start: {
          line: 60,
          column: 6
        },
        end: {
          line: 60,
          column: 63
        }
      },
      "17": {
        start: {
          line: 61,
          column: 6
        },
        end: {
          line: 61,
          column: 12
        }
      },
      "18": {
        start: {
          line: 63,
          column: 6
        },
        end: {
          line: 63,
          column: 87
        }
      },
      "19": {
        start: {
          line: 63,
          column: 27
        },
        end: {
          line: 63,
          column: 87
        }
      },
      "20": {
        start: {
          line: 64,
          column: 6
        },
        end: {
          line: 64,
          column: 12
        }
      },
      "21": {
        start: {
          line: 67,
          column: 2
        },
        end: {
          line: 72,
          column: 4
        }
      },
      "22": {
        start: {
          line: 75,
          column: 0
        },
        end: {
          line: 94,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "VerseObject",
        decl: {
          start: {
            line: 14,
            column: 9
          },
          end: {
            line: 14,
            column: 20
          }
        },
        loc: {
          start: {
            line: 20,
            column: 3
          },
          end: {
            line: 73,
            column: 1
          }
        },
        line: 20
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 16,
            column: 2
          },
          end: {
            line: 16,
            column: 18
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 16,
            column: 16
          },
          end: {
            line: 16,
            column: 18
          }
        }],
        line: 16
      },
      "1": {
        loc: {
          start: {
            line: 24,
            column: 2
          },
          end: {
            line: 65,
            column: 3
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 25,
            column: 4
          },
          end: {
            line: 27,
            column: 12
          }
        }, {
          start: {
            line: 28,
            column: 4
          },
          end: {
            line: 30,
            column: 12
          }
        }, {
          start: {
            line: 31,
            column: 4
          },
          end: {
            line: 39,
            column: 12
          }
        }, {
          start: {
            line: 40,
            column: 4
          },
          end: {
            line: 52,
            column: 12
          }
        }, {
          start: {
            line: 53,
            column: 4
          },
          end: {
            line: 55,
            column: 12
          }
        }, {
          start: {
            line: 56,
            column: 4
          },
          end: {
            line: 58,
            column: 12
          }
        }, {
          start: {
            line: 59,
            column: 4
          },
          end: {
            line: 61,
            column: 12
          }
        }, {
          start: {
            line: 62,
            column: 4
          },
          end: {
            line: 64,
            column: 12
          }
        }],
        line: 24
      },
      "2": {
        loc: {
          start: {
            line: 41,
            column: 6
          },
          end: {
            line: 51,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 41,
            column: 6
          },
          end: {
            line: 51,
            column: 7
          }
        }, {
          start: {
            line: 41,
            column: 6
          },
          end: {
            line: 51,
            column: 7
          }
        }],
        line: 41
      },
      "3": {
        loc: {
          start: {
            line: 63,
            column: 6
          },
          end: {
            line: 63,
            column: 87
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 63,
            column: 6
          },
          end: {
            line: 63,
            column: 87
          }
        }, {
          start: {
            line: 63,
            column: 6
          },
          end: {
            line: 63,
            column: 87
          }
        }],
        line: 63
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0],
      "1": [0, 0, 0, 0, 0, 0, 0, 0],
      "2": [0, 0],
      "3": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "b3ba7f1400cd4e75e3b09e71e95e24c5ab7b1db3"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ = require(".");

function VerseObject(_ref) {
  var verseObject = _ref.verseObject,
      _ref$originalWords = _ref.originalWords,
      originalWords = _ref$originalWords === void 0 ? (cov_1ydkxurojd.b[0][0]++, []) : _ref$originalWords,
      paragraphs = _ref.paragraphs,
      showUnsupported = _ref.showUnsupported,
      disableWordPopover = _ref.disableWordPopover;
  cov_1ydkxurojd.f[0]++;

  var _ref2 = (cov_1ydkxurojd.s[0]++, verseObject),
      type = _ref2.type;

  var component;
  cov_1ydkxurojd.s[1]++;

  switch (type) {
    case 'text':
      cov_1ydkxurojd.b[1][0]++;
      cov_1ydkxurojd.s[2]++;
      component = _react.default.createElement(_.TextObject, {
        verseObject: verseObject,
        paragraphs: paragraphs
      });
      cov_1ydkxurojd.s[3]++;
      break;

    case 'quote':
      cov_1ydkxurojd.b[1][1]++;
      cov_1ydkxurojd.s[4]++;
      component = _react.default.createElement(_.TextObject, {
        verseObject: verseObject
      });
      cov_1ydkxurojd.s[5]++;
      break;

    case 'milestone':
      cov_1ydkxurojd.b[1][2]++;
      cov_1ydkxurojd.s[6]++;
      component = _react.default.createElement(_.MilestoneObject, {
        verseObject: verseObject,
        originalWords: originalWords,
        disableWordPopover: disableWordPopover
      });
      cov_1ydkxurojd.s[7]++;
      break;

    case 'word':
      cov_1ydkxurojd.b[1][3]++;
      cov_1ydkxurojd.s[8]++;

      if (verseObject.strong) {
        cov_1ydkxurojd.b[2][0]++;
        cov_1ydkxurojd.s[9]++;
        component = _react.default.createElement(_.AlignedWordsObject, {
          children: [verseObject],
          originalWords: [verseObject],
          disableWordPopover: disableWordPopover
        });
      } else {
        cov_1ydkxurojd.b[2][1]++;
        cov_1ydkxurojd.s[10]++;
        component = _react.default.createElement(_.WordObject, {
          verseObject: verseObject,
          disableWordPopover: disableWordPopover
        });
      }

      cov_1ydkxurojd.s[11]++;
      break;

    case 'section':
      cov_1ydkxurojd.b[1][4]++;
      cov_1ydkxurojd.s[12]++;
      component = _react.default.createElement(_.SectionObject, {
        verseObject: verseObject
      });
      cov_1ydkxurojd.s[13]++;
      break;

    case 'paragraph':
      cov_1ydkxurojd.b[1][5]++;
      cov_1ydkxurojd.s[14]++;
      component = _react.default.createElement("div", null);
      cov_1ydkxurojd.s[15]++;
      break;

    case 'footnote':
      cov_1ydkxurojd.b[1][6]++;
      cov_1ydkxurojd.s[16]++;
      component = _react.default.createElement(_.FootnoteObject, {
        verseObject: verseObject
      });
      cov_1ydkxurojd.s[17]++;
      break;

    default:
      cov_1ydkxurojd.b[1][7]++;
      cov_1ydkxurojd.s[18]++;

      if (showUnsupported) {
        cov_1ydkxurojd.b[3][0]++;
        cov_1ydkxurojd.s[19]++;
        component = _react.default.createElement(_.UnsupportedObject, {
          verseObject: verseObject
        });
      } else {
        cov_1ydkxurojd.b[3][1]++;
      }

      cov_1ydkxurojd.s[20]++;
      break;
  }

  ;
  cov_1ydkxurojd.s[21]++;
  return _react.default.createElement(_react.default.Fragment, null, component, verseObject.nextChar);
}

;
cov_1ydkxurojd.s[22]++;
VerseObject.propTypes = {
  verseObject: _propTypes.default.shape({
    tag: _propTypes.default.string,
    type: _propTypes.default.string,
    content: _propTypes.default.string,
    children: _propTypes.default.arrayOf(_propTypes.default.object),
    strong: _propTypes.default.string,
    lemma: _propTypes.default.string,
    morph: _propTypes.default.string,
    occurrence: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
    occurrences: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
  }).isRequired,
  originalWords: _propTypes.default.array,

  /** render verses paragraphs, use explicit paragraphs */
  paragraphs: _propTypes.default.bool,

  /** render unsupported usfm markers */
  showUnsupported: _propTypes.default.bool,

  /** disable popovers for aligned and original language words */
  disableWordPopover: _propTypes.default.bool
};
var _default = VerseObject;
exports.default = _default;